import './application.css';
import * as Turbo from '@hotwired/turbo';
import 'flowbite/dist/flowbite.turbo.js';
import.meta.glob('~/**/*.ts', { eager: true });
import.meta.glob('../../packs/**/*.ts', { eager: true });

Turbo.start();
